import clsf from 'classnames';
import React, { FC, useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import config from '../config';
import ThemeContext from '../context/theme.context';
import { IconInstagram } from '../icons/instagram';
import { IconMoon } from '../icons/moon';
import { IconLogo } from '../icons/pacolor';
import { IconSun } from '../icons/sun';
import { IconTikTok } from '../icons/tiktok';
import { IconTwitter } from '../icons/twitter';

const Navbar: FC<More> = () => {
   const [scrolled, setScrolled] = useState(false);
   const theme = useContext(ThemeContext);

   useEffect(() => {
      const onScroll = () => {
         if (!scrolled && window.scrollY > 20) {
            setScrolled(true);
         } else if (window.scrollY <= 20) {
            setScrolled(false);
         }
      };
      window.addEventListener('scroll', onScroll);
      return () => {
         window.removeEventListener('scroll', onScroll);
      };
      // eslint-disable-next-line
   }, []);

   return (
      <>
         <div
            className={clsf('navbar w-100 fadeInDown', {
               scrolled,
            })}
         >
            <div className="container fx fx-rnw fx-jcsb fx-aic w-100">
               <div className="navbar-brand">
                  <Link to="/" className="fx fx-aic fx-cc">
                     <div className="icon">
                        <IconLogo />
                     </div>
                     <h1 className="title">{config.name}</h1>
                  </Link>
               </div>
               <div className="navbar-nav-menu-wrapper fx fx-dr fx-jcfe fx-aic">
                  <Link to="/likes">Likes</Link>
                  <Link to="/about">About</Link>
               </div>
               <div className="navbar-actions fx fx-rnw fx-cc">
                  {theme.dark ? (
                     <button onClick={theme.toggleDark} className="button">
                        <span className="icon">
                           <IconSun />
                        </span>
                     </button>
                  ) : (
                     <button onClick={theme.toggleDark} className="button">
                        <span className="icon">
                           <IconMoon />
                        </span>
                     </button>
                  )}

                  {/* eslint-disable-next-line */}
                  <a href="#" target="_blank" rel="noopener noreferrer">
                     <span className="icon">
                        <IconTikTok />
                     </span>
                  </a>
                  {/* eslint-disable-next-line */}
                  <a href="#" target="_blank" rel="noopener noreferrer">
                     <span className="icon">
                        <IconTwitter />
                     </span>
                  </a>
                  {/* eslint-disable-next-line */}
                  <a href="#" target="_blank" rel="noopener noreferrer">
                     <span className="icon">
                        <IconInstagram />
                     </span>
                  </a>
               </div>
            </div>
         </div>
      </>
   );
};

Navbar.propTypes = {};

export default Navbar;
